export const HTTP_CALL_STATUS = {
    UNKNOWN: 'UNKNOWN',
    LOADING: 'LOADING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
};

export const ERROR_CODES = {
    PARAM_INVALID: 4,
};

export const PUBLICATION_STATUS = {
    draft: 1,
    inReview: 2,
    published: 3,
};
